// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3zq-P","hiddenElements":"Header_hiddenElements__1IDyP","search":"Header_search__1jL0K","dark":"Header_dark__3DqUG","wrapper":"Header_wrapper__3K4-n"};